import { useQuery } from '@tanstack/react-query';
import { getInsuranceStatsBreakdown } from '../api';
import { INSURANCE_QUERY_KEY } from '../constants';
import { InsuranceBreakdownParams } from '../model';

/** Tanlangan ko'rsatkich bo'yicha viloyatlar kesimi. */
export const useInsuranceStatsBreakdown = (
  params: InsuranceBreakdownParams,
) => {
  return useQuery({
    queryKey: [INSURANCE_QUERY_KEY.STATS_BREAKDOWN, params],
    queryFn: () => getInsuranceStatsBreakdown(params),
    enabled: Boolean(params.metric && params.year),
  });
};
